import {FormDataDTO} from './FormDataDTO';

export class TestingFormData extends FormDataDTO {

  bodyChartAnatomiesDiagramId: any;

}
